// Re-export of the canonical shared save hook (fix wave F1 consolidation) —
// kept so existing imports from '@/components/map/use-save-listing' keep
// working. The real implementation, including per-listing op serialization
// and the once-per-uid saved-ids sync, lives in components/listings.
export { useSaveListing } from '@/components/listings/use-save-listing'
